import { useEffect, useRef } from 'react'
import { router } from '@inertiajs/react'
import i18n from '@/i18n'

/**
 * Asks before an Inertia visit (header links, "Back to Inspiration") leaves the editor with
 * unsaved work. Full page loads are covered by the editor's own beforeunload handler.
 * `allowNext()` lets one deliberate visit through (e.g. after the user already confirmed).
 */
export function useNavigationGuard(when, message) {
  const whenRef = useRef(when)
  const skipRef = useRef(false)
  whenRef.current = when

  useEffect(() => router.on('before', (event) => {
    if (skipRef.current) {
      skipRef.current = false
      return undefined
    }
    const visit = event.detail?.visit
    // Partial reloads and non-GET requests of the page itself are not navigation.
    if (!whenRef.current || (visit && visit.method && visit.method !== 'get')) return undefined
    if (!window.confirm(message || i18n.t('editorV2.shell.unsavedChanges'))) {
      event.preventDefault()
      return false
    }
    return undefined
  }), [message])

  return {
    allowNext: () => { skipRef.current = true },
  }
}
